
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card"
import { CategoryForm } from "./CategoryForm"

interface NewCategoryCardProps {
  onSave: () => void
}

export function NewCategoryCard({ onSave }: NewCategoryCardProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>New Category</CardTitle>
        <CardDescription>
          Create a new client category
        </CardDescription>
      </CardHeader>
      <CardContent>
        <CategoryForm 
          formId="category-form-new"
          onSave={onSave}
        />
      </CardContent>
    </Card>
  )
}
